<hs-lazy-load-panel [content]="lazyLoadPanelContent" [panelKey]="panelKey">
</hs-lazy-load-panel>
<ng-template #lazyLoadPanelContent>
  <div class="corporate-actions-layout">
    <ul
      ngbNav
      #topNav="ngbNav"
      [(activeId)]="activeTopTab"
      class="nav-tabs top-tabs"
      (activeIdChange)="onTopTabChange($event)"
    >
      <li [ngbNavItem]="1">
        <a
          class="top-nav-item"
          ngbNavLink
          data-testid="clearwater-corporate-actions-tab"
        >
          Clearwater Corporate Actions
        </a>
        <ng-template ngbNavContent>
          <div class="clearwater-layout">
            <div class="actions-grid-container" #cwGrid>
              <hs-corporate-actions-grid
                [accountId]="selectedAccountId"
                [issueId]="selectedIssueId"
                [userActions]="userActions"
                (corporateActionIdSelected$)="
                  setSelectedCorporateActionId($event)
                "
              >
              </hs-corporate-actions-grid>
            </div>
            <hs-resize-handle
              [elem1]="cwGrid"
              [elem2]="cwSubPanels"
              [direction]="ResizeDirection.Vertical"
              [initialResizeHandleState]="state?.clearwaterResizeHandleState"
              (resizeFinished)="onClearwaterResizeFinished($event)"
            ></hs-resize-handle>
            <div id="details-sub-panels" #cwSubPanels>
              <ul
                ngbNav
                #cwNav="ngbNav"
                [(activeId)]="activeBottomTab"
                class="nav-tabs"
              >
                <li [ngbNavItem]="1">
                  <a class="details-nav-item" ngbNavLink>
                    Corporate Action Details
                  </a>
                  <ng-template ngbNavContent>
                    <hs-corporate-actions-details
                      *ngIf="
                        corporateActionIdSelected;
                        else noSelectedCorporateAction
                      "
                      [currentCorporateActionId]="corporateActionIdSelected"
                      [accountId]="selectedAccountId"
                      [issueId]="selectedIssueId"
                    ></hs-corporate-actions-details>
                  </ng-template>
                </li>
                <li [ngbNavItem]="2">
                  <a class="details-nav-item" ngbNavLink> Account Summary </a>
                  <ng-template ngbNavContent>
                    <hs-account-summary
                      *ngIf="
                        corporateActionIdSelected;
                        else noSelectedCorporateAction
                      "
                      [currentCorporateActionId]="corporateActionIdSelected"
                    ></hs-account-summary>
                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="cwNav" class="mt-2"></div>
            </div>
          </div>
        </ng-template>
      </li>
      <li [ngbNavItem]="2" *ngIf="isInternalUser">
        <a
          class="top-nav-item"
          ngbNavLink
          data-testid="ice-corporate-actions-tab"
        >
          ICE Corporate Actions
        </a>
        <ng-template ngbNavContent>
          <div class="ice-layout">
            <div class="ice-table-pane" #iceTable>
              <hs-ice-corporate-actions-grid
                [selectedClientIds]="iceSelectedClientIds"
                [dateRange]="iceDateRange"
                [rowData]="iceRowData"
                (selectedClientIdsChanged$)="setIceSelectedClientIds($event)"
                (dateRangeChanged$)="setIceDateRange($event)"
                (rowDataChanged$)="setIceRowData($event)"
                (iceCorporateActionSelected$)="
                  setSelectedIceCorporateAction($event)
                "
                (loadStarted$)="selectedIceCorporateAction = undefined"
              >
              </hs-ice-corporate-actions-grid>
            </div>
            <hs-resize-handle
              [elem1]="iceTable"
              [elem2]="iceDetail"
              [direction]="ResizeDirection.Horizontal"
              [initialResizeHandleState]="state?.iceResizeHandleState"
              (resizeFinished)="onIceResizeFinished($event)"
            ></hs-resize-handle>
            <div class="ice-detail-pane" #iceDetail>
              <hs-ice-corporate-action-detail
                *ngIf="
                  selectedIceCorporateAction;
                  else noSelectedIceCorporateAction
                "
                [selectedAction]="selectedIceCorporateAction"
              ></hs-ice-corporate-action-detail>
            </div>
          </div>
        </ng-template>
      </li>
      <!--
        *ngIf="isInternalUser" — the SAME gate the ICE tab above carries, and it
        is deliberate rather than copied.

        This tab books financial corporate-action commands by hand, and its two
        external preconditions are not in production yet: PVAL-26137 adds the
        `/external` processing wrappers (so `processing/availableCommands` 404s in
        every environment today) and PVAL-25955 attaches the Control policy to a
        real role (so the dropdown is empty for every non-service caller until it
        lands). Ungated, every Helios user INCLUDING external clients would get a
        new top-level tab that can only render the red COMMANDS_LOAD_ERROR with a
        Retry that cannot succeed — the NO_COMMANDS_AVAILABLE empty state is gated
        on `!commandsError`, so a 404 never reaches it.

        DEPLOY ORDERING for this branch: PVAL-26137 must be deployed before this
        merges, and PVAL-25955 before the tab is useful to anyone. Widening the
        audience beyond internal users is a product decision that needs reporter
        sign-off; until then the narrower gate is the reversible direction (it is
        this one attribute), whereas shipping a broken tab to clients is not.

        [destroyOnHide] is load-bearing in BOTH directions, which is why it is a
        latched binding rather than a constant `false`.

        It must end up false, because ngbNav's default is destroy-on-hide and ALL
        of the Processing tab's retirement state (retired rows, submissionStatus,
        commandId, the UNCONFIRMED sentinel, cellLevelErrorMessageMap) is
        component-local on the child. Destroying it on a top-tab switch re-runs
        ngOnInit, resets the grid to one blank row with Submit re-enabled, and
        leaves NO in-grid record that the previous commands were queued — walking
        the user into a duplicate POST of a financial corporate action that
        nothing catches synchronously. Keeping the view alive also means an
        in-flight batch POST (toPromise()'d, not tied to destroyed$) still
        resolves against live row objects and a live gridApi.

        It must START true, because ngb-nav-outlet renders a `destroyOnHide:
        false` pane into the DOM IMMEDIATELY — a constant `false` here is EAGER,
        not lazy. That was measured, not assumed: it constructs
        CorporateActionsProcessingComponent (and therefore BlankSessionService)
        for every user who opens this panel, fires GET availableCommands even for
        a user who never opens this tab — an endpoint that 404s until PVAL-26137
        deploys — and made corporate-actions-panel.component.spec.ts red, which is
        a protected regression-gate file this branch may not touch.

        So the pane stays out of the DOM until the user first activates tab 3
        (onTopTabChange latches processingTabActivated), and is never destroyed
        after that. Same end state as the external-file-manager idiom
        (external-file-manager-panel.component.html:58,72), reached lazily.
      -->
      <li
        [ngbNavItem]="3"
        *ngIf="isInternalUser"
        [destroyOnHide]="!processingTabActivated"
      >
        <a
          class="top-nav-item"
          ngbNavLink
          data-testid="corporate-actions-processing-tab"
        >
          Corporate Actions Processing
        </a>
        <ng-template ngbNavContent>
          <hs-corporate-actions-processing></hs-corporate-actions-processing>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="topNav" class="top-tab-content"></div>

    <ng-template #noSelectedCorporateAction>
      <hs-panel-card header="No Corporate Action Selected">
        <p>
          This panel requires a coporate action to be selected before
          information can be displayed. Select a coporate action to continue.
        </p>
      </hs-panel-card>
    </ng-template>
    <ng-template #noSelectedIceCorporateAction>
      <hs-panel-card header="No ICE Corporate Action Selected">
        <p>Select an ICE corporate action row to view the raw JSON data.</p>
      </hs-panel-card>
    </ng-template>
  </div>
</ng-template>
